export enum RetriageFinishedStatus {
  ALREADY_MED = "ALREADY_MED",
  RECENTLY_RETRIAGED = "RECENTLY_RETRIAGED",
}
